export function Heading({ clicked }) {
  return (
    <div className="heading">
      {clicked == 0 && (
        <h2>
          About Me <hr />
        </h2>
      )}
      {clicked == 1 && (
        <h2>
          Resume <hr />
        </h2>
      )}
      {clicked == 2 && (
        <h2>
          Projects <hr />
        </h2>
      )}
      {clicked == 3 && (
        <h2>
          Contact <hr />
        </h2>
      )}
    </div>
  );
}
